// LongTextCell.tsx
import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { AlignLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface LongTextCellProps {
  value: any;
  config?: any;
  onChange?: (value: string) => void;
  readOnly?: boolean;
}

export const LongTextCell: React.FC<LongTextCellProps> = ({ value, config, onChange, readOnly }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [editValue, setEditValue] = useState('');

  let textValue = '';
  try {
    if (typeof value === 'string') {
      textValue = value;
    } else if (value?.text !== undefined) {
      textValue = value.text;
    } else {
      textValue = String(value || '');
    }
  } catch (e) {
    textValue = '';
  }

  const handleOpen = () => {
    setEditValue(textValue);
    setIsOpen(true);
  };

  const handleSave = () => {
    if (onChange) {
      onChange(editValue);
    }
    setIsOpen(false);
  };

  const truncated = textValue.length > 50 ? textValue.slice(0, 50) + '...' : textValue;

  return (
    <>
      <button
        onClick={handleOpen}
        className="w-full px-3 py-1.5 text-sm hover:bg-gray-50 rounded flex items-center gap-2 text-left"
      >
        <AlignLeft className="w-4 h-4 text-gray-400" />
        <span className="truncate text-gray-600">{truncated || '-'}</span>
      </button>

      <Dialog open={isOpen} onOpenChange={setIsOpen}>
        <DialogContent className="max-w-2xl">
          <DialogHeader>
            <DialogTitle>Texto Longo</DialogTitle>
          </DialogHeader>
          <div className="space-y-4">
            <textarea
              value={editValue}
              onChange={(e) => setEditValue(e.target.value)}
              className="w-full h-64 px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none"
              placeholder="Digite o texto..."
              disabled={readOnly}
            />
            {!readOnly && (
              <div className="flex justify-end gap-2">
                <Button variant="outline" onClick={() => setIsOpen(false)}>
                  Cancelar
                </Button>
                <Button onClick={handleSave}>Salvar</Button>
              </div>
            )}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
